/**
 * @todo Documentation
 * @todo Adapt to module template
 * @todo Syntax check (lint)
 */

var EN = EN || {};

EN.VideoHelper = EN.VideoHelper || {};

(function(_, $) {
	EN.VideoHelper.initEventBubblingForVideo = function() {
		// http://stackoverflow.com/questions/11291651/why-dont-audio-and-video-events-bubble
		if (typeof $.createEventCapturing === 'undefined') {
			$.createEventCapturing = (function () {
				var special = $.event.special;
				return function (names) {
					if (!document.addEventListener) {
						return;
					}
					if (typeof names == 'string') {
						names = [names];
					}
					$.each(names, function (i, name) {
						var handler = function (e) {
							e = $.event.fix(e);

							return $.event.dispatch.call(this, e);
						};
						special[name] = special[name] || {};
						if (special[name].setup || special[name].teardown) {
							return;
						}
						$.extend(special[name], {
							setup: function () {
								this.addEventListener(name, handler, true);
							},
							teardown: function () {
								this.removeEventListener(name, handler, true);
							}
						});
					});
				};
			})();
		}

		$.createEventCapturing(['play', 'pause', 'timeupdate']);
	};

	EN.VideoHelper.initVideoClick = function() {
		$(document).on('click', '.en-video', function() {
			var video = this;
			if (video.paused === true) video.play();
			else video.pause();
		});
	};

	EN.VideoHelper.initControlButtons = function() {
		$(document).on('click', '.en-video__control-button', function() {
			var $controlButton = $(this);
			var $videoContainer = $controlButton.closest(EN.VideoHelper.$videoContainers);
			var $video = $videoContainer.find('.en-video');
			var video = $video.get(0);
			var action = $controlButton.attr('data-en-video-control-action');

			if (!action || !video) return;

			if (action === 'play_toggle') {
				if (video.paused === true) video.play();
				else video.pause();
			}
			else if (action === 'play') {
				video.play();
			}
			else if (action === 'pause') {
				video.pause();
			}
			else if (action === 'stop') {
				video.pause();
				video.currentTime = 0;
				// video.load();
				$video.trigger('reset');
			}
			else if (action === 'mute_toggle') {
				video.muted = !video.muted;
			}
			else if (action === 'mute') {
				video.muted = true;
			}
			else if (action === 'unmute') {
				video.muted = false;
			}
			else if (action === 'fullscreen') {
				if (video.requestFullscreen) {
					video.requestFullscreen();
				} else if (video.mozRequestFullScreen) {
					video.mozRequestFullScreen(); // Firefox
				} else if (video.webkitRequestFullscreen) {
					video.webkitRequestFullscreen(); // Chrome and Safari
				}
			}
		});
	};

	EN.VideoHelper.initProgressBar = function() {
		$(document).on('timeupdate', '.en-video', _.throttle(function() {
			var video = this;
			var $video = $(video);
			var $videoContainer = $video.closest(EN.VideoHelper.$videoContainers);
			var $progressbar = $videoContainer.find('.en-video__progressbar');

			if (!video || $videoContainer.length === 0 || $progressbar.length === 0) return;

			var progress = Math.round((100 / video.duration) * video.currentTime * 100) / 100;
			$progressbar.css({width: progress + '%'});

		}, 100));
	};

	EN.VideoHelper.initContainerAttributes = function() {
		$(document).on('play pause', '.en-video', _.throttle(function() {
			var video = this;
			var $video = $(video);
			var $videoContainer = $video.closest(EN.VideoHelper.$videoContainers);

			if (!video || $videoContainer.length === 0) return;

			$videoContainer.attr('data-en-video-state', video.paused === true ? 'paused' : 'playing');
		}, 200));

		$(document).on('reset', '.en-video', _.throttle(function() {
			var video = this;
			var $video = $(video);
			var $videoContainer = $video.closest(EN.VideoHelper.$videoContainers);

			if (!video || $videoContainer.length === 0) return;

			$videoContainer.removeAttr('data-en-video-state');
		}, 200));
	};

	$(function() {
		EN.VideoHelper.$videoContainers = $('.en-video__container');

		// EN.VideoHelper.$videoContainers.each(function() {
		// 	var $videoContainer = $(this);
		// });

		if (EN.VideoHelper.$videoContainers.length) {
			EN.VideoHelper.initEventBubblingForVideo();

			EN.VideoHelper.initVideoClick();
			EN.VideoHelper.initControlButtons();
			EN.VideoHelper.initProgressBar();
			EN.VideoHelper.initContainerAttributes();
		}
	});
}(lodash, jQuery));
